function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "grad10",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#cc31ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "90%",
  stopColor: "#19f2c8"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Livello_2-2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#grad10)",
  d: "M48.94,1.79,45.94,13a1.42,1.42,0,0,1-2.37.63l-2.66-2.66-9.35,9.34a6.66,6.66,0,0,1-9.42,0L15.3,13.43a1.66,1.66,0,0,0-2.35,0L4.27,22.11a2.51,2.51,0,0,1-3.54,0,2.52,2.52,0,0,1,0-3.54L9.42,9.89a6.65,6.65,0,0,1,9.41,0l6.85,6.85a1.68,1.68,0,0,0,2.35,0l9.34-9.35-2-2A1.42,1.42,0,0,1,36,3L47.2.05A1.42,1.42,0,0,1,48.94,1.79Z"
})));

var SvgActiveUsers = function SvgActiveUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48.99 22.84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActiveUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activeUsers.37a0194d.svg";
export { ForwardRef as ReactComponent };